/**
 * Simple debounce for function execution, without
 * using vue lifecycle.
 */
export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number,
  options: {
    /** the leading option will trigger the debounce right away the first time */
    leading?: boolean
  } = { leading: false },
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  let lastArgs: Parameters<T> | null = null

  return (...args: Parameters<T>) => {
    lastArgs = args
    if (!timeoutId && options.leading) func(...args)
    if (timeoutId) clearTimeout(timeoutId)

    timeoutId = setTimeout(() => {
      if (!options.leading && lastArgs) func(...lastArgs)
      timeoutId = null
    }, delay)
  }
}
